import { render, staticRenderFns } from "./PhotoBlock.vue?vue&type=template&id=c40b1278&scoped=true&lang=pug&"
import script from "./PhotoBlock.vue?vue&type=script&lang=js&"
export * from "./PhotoBlock.vue?vue&type=script&lang=js&"
import style0 from "./PhotoBlock.vue?vue&type=style&index=0&id=c40b1278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40b1278",
  null
  
)

export default component.exports